/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Extensive9Inputs */

const en_cv_extract_form_enum_extensive9 = /** @type {(inputs: Cv_Extract_Form_Enum_Extensive9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensive experience`)
};

const de_cv_extract_form_enum_extensive9 = /** @type {(inputs: Cv_Extract_Form_Enum_Extensive9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Erfahrung`)
};

/**
* | output |
* | --- |
* | "Extensive experience" |
*
* @param {Cv_Extract_Form_Enum_Extensive9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_extensive9 = /** @type {((inputs?: Cv_Extract_Form_Enum_Extensive9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Extensive9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_extensive9(inputs)
	return en_cv_extract_form_enum_extensive9(inputs)
});
export { cv_extract_form_enum_extensive9 as "cv_extract_form_enum_EXTENSIVE" }